// Author Lin
// Date 2021-10-20 17:00:32

import * as model from "@/model/mintalMes/inventory/MintalMesInventoryInputOutputModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesInventoryInputOutput(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_INVENTORY_URL,
    })
    .buildStore()
